export default {
  getNotice: (state) => state.notice,
  getFaq: (state) => state.faq,
  getAsk: (state) => state.ask,
};
